import { render, staticRenderFns } from "./CancelOrderCreation.vue?vue&type=template&id=1524b88f"
import script from "./CancelOrderCreation.js?vue&type=script&lang=js&external"
export * from "./CancelOrderCreation.js?vue&type=script&lang=js&external"
import style0 from "./CancelOrderCreation.vue?vue&type=style&index=0&id=1524b88f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports